const config = {
  builder_id: '5c76d5814db048256d98aec4',
  auth_domain: 'blockonecommunities.com',
  entity_logos: {
    plan: 'elevationPhotos[0]',
    community: 'logo',
    home: 'photos[0]',
  },
  social_links: {
    facebook: '/images/icon-social-facebook.svg',
    instagram: '/images/icon-social-instagram.svg',
    youtube: '/images/icon-social-youtube.svg',
    pinterest: '/images/icon-social-pinterest.svg',
    twitter: '/images/icon-social-twitter.svg',
    houzz: '/images/icon-social-houzz.svg',
    linkedin: '/images/icon-social-linkedin.svg',
    googleplus: '/images/icon-social-google-plus.svg',
    fallback: '/images/icon-social-baths.svg',
  },
  mapbox: {
    key: 'pk.eyJ1IjoiYnVpbGRlcmRlc2lnbnMiLCJhIjoiY2ptZ2c4b2p1MjJsdTNybnl2ZnV6bjg2OSJ9.uekOiNqFfTxBQ1evHIpc9g',
  },
  filters: {
    all: {
      Area: {
        routeParam: 'communityMarketArea',
      },
    },
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/configuration.js